import { Component, Input, NgZone, ElementRef } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map'
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { httpService } from '../service/servicio'
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';

import * as jsPDF from 'jspdf'



@Component({
  selector: 'app-recaudaciones',
  templateUrl: './recaudaciones.component.html',
  styleUrls: ['./recaudaciones.component.css']


})
export class RecaudacionesComponent {


  constructor(private http: httpService, public toastr: ToastsManager, vcr: ViewContainerRef, private elem: ElementRef) {

    this.toastr.setRootViewContainerRef(vcr);

    this.loaded = false;
    //this.miDate =  new Date(Date.parse(this.hoy()));
    this.descargarRecaudaciones();



  };


  uploaded = {
    Status: 0,
    Text: ''

  }

  public fInicio: string = this.hoy();
  public fFinal: string = this.hoy();

  @Input() recaudaciones: any = [];
  @Input() maquinas: any = [];

  tituloRecaudaciones: string = '';
  recaudacionesSearch: string = '';
  maquinaSearch: string = '';
  place: string = 'Buscar por Cliente';
  sort: string = 'DescCliente';
  mostrarDatosRecaudacion: boolean = false;
  loaded: boolean = false;
  sum: number = 0.0;
  stringFiltro: string = 'Cliente'
  contadorAnterior: any;
  diferencia: any;
  nuevarec: boolean = false;
  mostrarAnterior:boolean = false;
  indice = 0;


  listar() {

    // Only pt supported (not mm or in)

    let doc = new jsPDF('p', 'pt');

    doc.setFont("courier");
    doc.setFontSize(14);
    doc.setFontType("bold");

    doc.text(15, 20, "Listado de Recaudaciones ( " + this.filtro().length + " )")
    doc.setFontSize(10);
    if (this.recaudacionesSearch != '') doc.text(15, 40, "Filtro: " + this.stringFiltro + ' = ' + this.recaudacionesSearch);
    doc.text(15, 60, "Recaudaciones del " + this.http.fecha(this.fInicio) + " al " + this.http.fecha(this.fFinal));
    doc.text(500, 20, this.http.hoy())
    doc.line(15, 25, 585, 25);

    let lineas: any = [];
    let y: number = 80;


    doc.setFontType("normal");
    /*
      doc.text(0,5, '12345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890');
      doc.text(0,15,'         1         2         3         4         5         6         7         8         9         10       11        12        13        14');
      for (let i=0; i < 800; i+=10) {

        doc.text(i, 25,".");
        doc.text(5,i,".");
      }
      let ii:number = 0;
      let c:number = 0;

      for (let i=0; i < 800; i+=10) {
        ii ++;
        if (ii == 10) {
          c++;
          doc.text(i, 25, c.toString());
          doc.text(10, i, c.toString());

          ii = 0 };

      }
    */
    doc.setFontSize(10);
    doc.setFontType("bold");

    doc.text(15, y, 'Id');
    doc.text(45, y, 'Fecha');
    doc.text(120, y, 'Maquina');
    doc.text(250, y, 'Cliente');
    doc.text(450, y, 'Importe');
    doc.text(500, y, 'Dev.');
    doc.text(540, y, 'Cont.');
    doc.line(15, y + 5, 585, y + 5)

    y = 100;
    doc.setFontType("normal");
    let sw: boolean = true;

    let tabla: any = this.filtro();

    tabla.forEach(recaudacion => {
      if (sw) {
        doc.setTextColor(128, 128, 128)
      } else {
        doc.setTextColor(0, 0, 0)
      }

      let maquina: string = recaudacion.Descmarca + ' ' + recaudacion.Descmodelo;



      doc.text(15, y, recaudacion.IdMaquina);
      doc.text(45, y, this.http.fecha(recaudacion.Fecha));
      doc.text(120, y, maquina.slice(0, 20));
      doc.text(250, y, recaudacion.DescCliente.slice(0, 30));
      doc.text(450, y, parseInt(recaudacion.Importe).toFixed(2));
      doc.text(505, y, parseInt(recaudacion.Devolucion).toFixed(2));
      doc.text(540, y, recaudacion.contador);
      //doc.line(15, y + 8, 585, y + 8)


      sw = !sw;

      y += 20;
      if (y > 800) { doc.addPage(); y = 35 }

    })

    y += 30;
    doc.setFontType("bold");

    let suma = this.suma();
    let devolucion = this.devolucion()
    suma = parseFloat(suma).toFixed(2);
    devolucion = parseFloat(devolucion).toFixed(2);


    doc.text(250, y, "Totales:");
    doc.text(450, y, suma.toString());
    doc.text(505, y, devolucion.toString());

    doc.save('Recaudaciones.pdf');

  }

  orden(n) {
    if (n == 1) { this.sort = 'Id'; this.place = 'Buscar por Id'; this.stringFiltro = "Id" };
    if (n == 2) { this.sort = 'IdMaquina'; this.place = 'Buscar por Maquina'; this.stringFiltro = "Maquina" };
    if (n == 3) { this.sort = 'DescCliente'; this.place = 'Buscar por Cliente'; this.stringFiltro = "Cliente" };
    if (n == 4) { this.sort = 'DescPosicion'; this.place = 'Buscar por Posicion'; this.stringFiltro = "Posicion" };
    if (n == 5) { this.sort = 'Descmarca'; this.place = 'Buscar por Marca'; this.stringFiltro = "Marca" };
    if (n == 6) { this.sort = 'Descmodelo'; this.place = 'Buscar por Modelo'; this.stringFiltro = "Modelo" };
    if (n == 7) { this.sort = 'descripcion'; this.place = 'Buscar por Descripcion'; this.stringFiltro = "Descripcion" };

  }

  quitarfiltro(tipo: Number) {
    this.recaudacionesSearch = '';
  }

  mitime(tiempo) {
    console.log("time: ", tiempo.slice(0,5))
    return tiempo.slice(0,5);
  }

  hoy() {

    let today = new Date();
    let dd = today.getDate().toString();
    let mm = (today.getMonth() + 1).toString();
    let yyyy: string;


    if (today.getDate() < 10) {

      dd = '0' + dd;
    }

    if (today.getMonth() < 10) {
      mm = '0' + mm;
    }

    yyyy = today.getFullYear().toString();

    let fecha = yyyy + '-' + mm + '-' + dd;

    return fecha;

  }

  suma() {
    return (this.filtro().reduce((sum, item) => sum + (+item.Importe), 0))
  }

  devolucion() {
    return (this.filtro().reduce((sum, item) => sum + (+item.Devolucion), 0))
  }

  filtro() {

    return this.recaudaciones.filter((recaudacion) => {
      if (this.sort == 'Id') {
        return recaudacion.Id.toLowerCase().indexOf(this.recaudacionesSearch.toLowerCase()) != -1;
      }
      if (this.sort == 'IdMaquina') {
        return recaudacion.IdMaquina.toLowerCase().indexOf(this.recaudacionesSearch.toLowerCase()) != -1;
      }
      if (this.sort == 'Fecha')
        return recaudacion.Fecha.toLowerCase().indexOf(this.recaudacionesSearch.toLowerCase()) != -1;
      if (this.sort == 'DescCliente')
        return recaudacion.DescCliente.toLowerCase().indexOf(this.recaudacionesSearch.toLowerCase()) != -1;
      if (this.sort == 'DescPosicion')
        return recaudacion.DescPosicion.toLowerCase().indexOf(this.recaudacionesSearch.toLowerCase()) != -1;
      if (this.sort == 'Descmarca')
        return recaudacion.Descmarca.toLowerCase().indexOf(this.recaudacionesSearch.toLowerCase()) != -1;
      if (this.sort == 'Descmodelo')
        return recaudacion.Descmodelo.toLowerCase().indexOf(this.recaudacionesSearch.toLowerCase()) != -1;
      if (this.sort == 'descripcion')
        return recaudacion.descripcion.toLowerCase().indexOf(this.recaudacionesSearch.toLowerCase()) != -1;

    });
  }

  filtromaquina() {
    return this.maquinas.filter((maquina) => {
      return maquina.Desccliente.toLowerCase().indexOf(this.maquinaSearch.toLowerCase()) != -1;
    });
  }

  zero: boolean = false;

  descargarRecaudaciones() {

    this.http.descargarRecaudaciones(this.fInicio, this.fFinal)
      .subscribe(recaudacion => {
        this.recaudaciones = recaudacion;
        if (!this.zero)
          this.recaudaciones = this.recaudaciones.filter( r => Number(r.Importe) > 0)
      

      }, err => {

      }, () => {
        if (this.recaudaciones == null) {

          this.toastr.warning("No existen recaudaciones", "Recaudaciones");

        }
        //this.orden(2);
        this.loaded = true;
        console.log(this.recaudaciones)


      });
  }

  descargarMaquinas() {
    this.http.descargarMaquinas(0)
      .subscribe(maquina => {
        this.maquinas = maquina;

      }, err => {

      }, () => {

      });
  }

  pulsado(recaudacion) {
    this.maquinaSearch = '';
    this.nuevarec = false;
    this.http.descargarMaquinas(0)
      .subscribe(maquina => {
        this.maquinas = maquina;

      }, err => {

      }, () => {

        this.http.recaudacionGrabar = this.http.nuevaRecaudacion();
        this.http.recaudacionGrabar.Id = recaudacion.Id;
        this.http.recaudacionGrabar.IdMaquina = recaudacion.IdMaquina;
        this.http.recaudacionGrabar.IdPosicion = recaudacion.IdPosicion;
        this.http.recaudacionGrabar.IdCliente = recaudacion.IdCliente;
        this.http.recaudacionGrabar.Importe = recaudacion.Importe;
        this.http.recaudacionGrabar.Cambio = recaudacion.Cambio;
        this.http.recaudacionGrabar.Devolucion = recaudacion.Devolucion;
        this.http.recaudacionGrabar.Fecha = recaudacion.Fecha;
        this.http.recaudacionGrabar.contador = recaudacion.contador;
        this.http.recaudacionGrabar.precioservicio = recaudacion.precioservicio;
        this.http.recaudacionGrabar.hora =recaudacion.hora;
        (this.http.recaudacionGrabar)
        this.tituloRecaudaciones = 'Editando Recaudacion'
        this.mostrarDatosRecaudacion = true;

      });

  }

  crearRecaudacion() {
    ("Pulsado Crear");
    this.maquinaSearch = '';
    this.contadorAnterior = 0;
    this.nuevarec = true;
    this.http.recaudacionGrabar = this.http.nuevaRecaudacion();
    this.http.descargarMaquinas(0)
      .subscribe(maquina => {
        this.maquinas = maquina;

      }, err => {
        (err.message);
      }, () => {
        this.http.recaudacionGrabar.IdMaquina = this.maquinas[0].IdMaquina;
        this.contadorAnterior = this.maquinas[0].contador;

        this.diferencia = this.http.recaudacionGrabar.contador - this.contadorAnterior
        this.http.recaudacionGrabar.Fecha = this.hoy();
        this.nuevarec = true;
        this.mostrarDatosRecaudacion = true;
      });
  }

  selMaquina(Id) {
    /*
    this.http.recaudacionGrabar.IdMaquina = Id;
    let desc = this.maquinas.find(maquina => maquina.Id == Id ).descripcion
    this.contadorAnterior = this.maquinas.find(maquina => maquina.Id == Id ).contador
*/

    this.indice = Id;
    console.log("I: ", Id)


  }

  volver() {
    this.http.sw.mostrarDatosmaquinas = true;
    this.toastr.warning("Cargando Datos...", "Internet");
  }

  cancelar() {

    this.mostrarDatosRecaudacion = false;

  }

  borrarpulsado(recaudacion) {
    ("Borrar pulsado");
    this.http.recaudacionGrabar = recaudacion;
  }

  borrar() {

    this.http.datosPost.action = 2; // borrar
    this.http.datosPost.datos = this.http.recaudacionGrabar;
    this.http.recaudacion(this.http.datosPost).subscribe(respuesta => {
      this.http.uploaded = respuesta;

    }, err => {
      (err.message);
    }, () => {
      if (this.http.uploaded.Status == 1) {
        this.toastr.success(this.http.uploaded.Text, 'Recaudacion');
        this.http.descargarRecaudaciones(this.fInicio, this.fFinal).subscribe(respuesta => {
          this.recaudaciones = respuesta;
        });
      } else {

        this.toastr.error(this.http.uploaded.Text, 'Recaudacion');
      }
    });
  }

  grabar() {
    let id = (<HTMLInputElement>document.getElementById('combo')).value;
    let maquinaactual = this.maquinas.find(maquina => maquina.Id === id)

    this.http.recaudacionGrabar.IdMaquina = id;
    this.http.recaudacionGrabar.IdPosicion = maquinaactual.posicion;
    this.http.recaudacionGrabar.IdCliente = maquinaactual.Idcliente;

    this.http.datosPost.action = 1; // por defecto Update
    if (this.http.recaudacionGrabar.Id == 0) this.http.datosPost.action = 0; // si es nueva Insert;
    this.http.datosPost.datos = this.http.recaudacionGrabar;

    this.http.recaudacion(this.http.datosPost).subscribe(respuesta => {
      this.http.uploaded = respuesta;

    }, err => {

    }, () => {
      if (this.http.uploaded.Status == 1) {
        this.toastr.success(this.http.uploaded.Text, 'Recaudacion');
        this.http.descargarRecaudaciones(this.fInicio, this.fFinal).subscribe(respuesta => {
          this.recaudaciones = respuesta;
          this.mostrarDatosRecaudacion = false;
        });
      } else {
        this.toastr.error(this.http.uploaded.Text, 'Recaudacion');
      }
    });

  }

  getContador() {

    this.mostrarAnterior =true;
    let id = (<HTMLInputElement>document.getElementById('combo')).value;
    let maquinaactual = this.maquinas.find(maquina => maquina.Id === id)

    this.contadorAnterior = maquinaactual.contador;


  }

}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/recaudaciones/recaudaciones.component.ts